module.exports = require("babel-runtime/core-js/set");


//////////////////
// WEBPACK FOOTER
// external "babel-runtime/core-js/set"
// module id = 13
// module chunks = 0